<template>
  <div>
    <top-message />
    <div class="bottomPart">
      <div class="titlePart">产品管理</div>
      <!-- 发布新产品 -->
      <div
        v-if="f"
        class="form"
      >
        <el-form
          :model="submitForm"
          :rules="submitRule"
          ref="submitForm"
          label-width="100px"
          class="demo-ruleForm"
        >

          <el-form-item
            label="产品类型"
            prop="typeId"
          >
            <el-select
              v-model="submitForm.typeId"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(item,index) in selectProTypeList"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="产品名称"
            prop="name"
          >
            <el-input
              type="textarea"
              v-model="submitForm.name"
              maxlength="50"
              placeholder="请输入产品名称"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="产品介绍"
            prop="proIntroduction"
          >
            <el-input
              type="textarea"
              v-model="submitForm.proIntroduction"
              maxlength="500"
              placeholder="请输入产品介绍"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="贷款额度"
            required
          >
            <el-col :span="11">
              <el-form-item prop="loanLimitFloor">
                <el-input-number
                  v-model="submitForm.loanLimitFloor"
                  :min="0"
                  :max="submitForm.loanLimitCap || maxNumber"
                  :controls="false"
                  :precision="0"
                  style="width: 80%"
                />万元
              </el-form-item>
            </el-col>
            <el-col
              class="line"
              :span="2"
              style="text-align: center"
            >-</el-col>
            <el-col :span="11">
              <el-form-item prop="loanLimitCap">
                <el-input-number
                  v-model="submitForm.loanLimitCap"
                  :min="submitForm.loanLimitFloor || 0"
                  :max="maxNumber"
                  :controls="false"
                  :precision="0"
                  style="width: 80%"
                />万元
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            label="利率范围"
            required
          >
            <el-col :span="11">
              <el-form-item prop="interestRateFloor">
                <el-input-number
                  v-model="submitForm.interestRateFloor"
                  :min="0"
                  :max="submitForm.interestRateCap || maxNumber"
                  :controls="false"
                  :precision="2"
                  style="width: 80%"
                />%
              </el-form-item>
            </el-col>
            <el-col
              class="line"
              :span="2"
              style="text-align: center"
            >-</el-col>
            <el-col :span="11">
              <el-form-item prop="interestRateCap">
                <el-input-number
                  v-model="submitForm.interestRateCap"
                  :min="submitForm.interestRateFloor || 0"
                  :max="maxNumber"
                  :controls="false"
                  :precision="2"
                  style="width: 80%"
                />%
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item
            label="贷款期限"
            required
          >
            <el-col :span="11">
              <el-form-item prop="minLoanTime">
                <el-input-number
                  v-model="submitForm.minLoanTime"
                  :min="0"
                  :max="submitForm.maxLoanTime || maxNumber"
                  :controls="false"
                  :precision="0"
                  style="width: 80%"
                />月
              </el-form-item>
            </el-col>
            <el-col
              class="line"
              :span="2"
              style="text-align: center"
            >-</el-col>
            <el-col :span="11">
              <el-form-item prop="maxLoanTime">
                <el-input-number
                  v-model="submitForm.maxLoanTime"
                  :min="submitForm.minLoanTime || 0"
                  :max="maxNumber"
                  :controls="false"
                  :precision="0"
                  style="width: 80%"
                />月
              </el-form-item>

            </el-col>
          </el-form-item>
          <el-form-item
            label="贷款类型"
            prop="type"
          >
            <el-select
              v-model="submitForm.type"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in typeOption"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="申请条件"
            prop="conditions"
          >
            <el-input
              type="textarea"
              v-model="submitForm.conditions"
              maxlength="200"
              placeholder="请输入申请条件"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="所需材料"
            prop="materials"
          >
            <el-input
              type="textarea"
              v-model="submitForm.materials"
              maxlength="200"
              placeholder="请输入所需材料"
            ></el-input>
          </el-form-item>

          <el-form-item label="Web链接">
            <el-input
              type="textarea"
              v-model="submitForm.webUrl"
              maxlength="200"
              placeholder="请输入Web端跳转链接"
            ></el-input>
          </el-form-item>

          <el-form-item label=" H5链接">
            <el-input
              type="textarea"
              v-model="submitForm.h5Url"
              maxlength="200"
              placeholder="请输入h5跳转链接"
            ></el-input>
          </el-form-item>

          <div style="text-align: center;margin-top: 50px">
            <el-button
              type="primary"
              @click="handleSubmit"
              :loading="submitLoading"
            >确认发布</el-button>
          </div>
        </el-form>
      </div>
      <!-- 发布成功 -->
      <div
        v-if="success"
        class="show"
      >
        <div class="a1">
          <img
            class="b1"
            :src="baseUrl + Url"
            alt=""
          />
          <div class="b2">{{ showInfo.name }}</div>
          <div class="b3">{{ showInfo.typeName }}贷款</div>
          <div class="b4">
            <div class="c">
              <div class="d1 d2">
                {{ showInfo.interestRateFloor }}-{{ showInfo.interestRateCap }}
              </div>
              <div class="d3">年利率（%）</div>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="c">
              <div class="d1">
                {{ showInfo.loanLimitFloor }}-{{ showInfo.loanLimitCap }}</div>
              <div class="d3">额度（万元）</div>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="c">
              <div class="d1">
                {{ showInfo.minLoanTime }}-{{ showInfo.maxLoanTime }}</div>
              <div class="d3">贷款（月）</div>
            </div>
          </div>
        </div>
        <img
          class="a2"
          src="../../assets/images/product.png"
          alt=""
        />
        <div class="a3">您的产品上线需求已提交，审批进度请咨询65229367</div>
        <div style="margin-top: 30px;">
          <el-button @click="Return">返回产品列表</el-button>
        </div>
      </div>
      <!-- 修改产品属性 -->
      <div
        v-if="modifyStatus"
        class="form"
      >
        <el-form
          :model="ModifyForm"
          :rules="submitRule"
          ref="submitForm"
          label-width="100px"
          class="demo-ruleForm"
        >

          <el-form-item
            label="产品类型"
            prop="typeId"
          >
            <el-select
              v-model="ModifyForm.typeId"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(item,index) in selectProTypeList"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="产品介绍"
            prop="name"
          >
            <el-input
              type="textarea"
              v-model="ModifyForm.name"
              maxlength="200"
              placeholder="请输入产品介绍"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="贷款额度"
            required
          >
            <el-col :span="11">
              <el-form-item prop="loanLimitFloor">
                <el-input-number
                  v-model="ModifyForm.loanLimitFloor"
                  :min="0"
                  :max="ModifyForm.loanLimitCap || maxNumber"
                  :controls="false"
                  :precision="0"
                  style="width: 80%"
                />万元
              </el-form-item>
            </el-col>
            <el-col
              class="line"
              :span="2"
              style="text-align: center"
            >-</el-col>
            <el-col :span="11">
              <el-form-item prop="loanLimitCap">
                <el-input-number
                  v-model="ModifyForm.loanLimitCap"
                  :min="ModifyForm.loanLimitFloor || 0"
                  :max="maxNumber"
                  :controls="false"
                  :precision="0"
                  style="width: 80%"
                />万元
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            label="利率范围"
            required
          >
            <el-col :span="11">
              <el-form-item prop="interestRateFloor">
                <el-input-number
                  v-model="ModifyForm.interestRateFloor"
                  :min="0"
                  :max="ModifyForm.interestRateCap || maxNumber"
                  :controls="false"
                  :precision="2"
                  style="width: 80%"
                />%
              </el-form-item>
            </el-col>
            <el-col
              class="line"
              :span="2"
              style="text-align: center"
            >-</el-col>
            <el-col :span="11">
              <el-form-item prop="interestRateCap">
                <el-input-number
                  v-model="ModifyForm.interestRateCap"
                  :min="ModifyForm.interestRateFloor || 0"
                  :max="maxNumber"
                  :controls="false"
                  :precision="2"
                  style="width: 80%"
                />%
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item
            label="贷款期限"
            required
          >
            <el-col :span="11">
              <el-form-item prop="minLoanTime">
                <el-input-number
                  v-model="ModifyForm.minLoanTime"
                  :min="0"
                  :max="ModifyForm.maxLoanTime || maxNumber"
                  :controls="false"
                  :precision="0"
                  style="width: 80%"
                />月
              </el-form-item>
            </el-col>
            <el-col
              class="line"
              :span="2"
              style="text-align: center"
            >-</el-col>
            <el-col :span="11">
              <el-form-item prop="maxLoanTime">
                <el-input-number
                  v-model="ModifyForm.maxLoanTime"
                  :min="ModifyForm.minLoanTime || 0"
                  :max="maxNumber"
                  :controls="false"
                  :precision="0"
                  style="width: 80%"
                />月
              </el-form-item>

            </el-col>
          </el-form-item>
          <el-form-item
            label="贷款类型"
            prop="type"
          >
            <el-select
              v-model="ModifyForm.type"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in typeOption"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="申请条件"
            prop="conditions"
          >
            <el-input
              type="textarea"
              v-model="ModifyForm.conditions"
              maxlength="200"
              placeholder="请输入申请条件"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="所需材料"
            prop="materials"
          >
            <el-input
              type="textarea"
              v-model="ModifyForm.materials"
              maxlength="200"
              placeholder="请输入所需材料"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="Web链接"
            prop="webUrl"
          >
            <el-input
              type="textarea"
              v-model="ModifyForm.webUrl"
              maxlength="200"
              placeholder="请输入Web端跳转链接"
            ></el-input>
          </el-form-item>

          <el-form-item
            label=" H5链接"
            prop="h5Url"
          >
            <el-input
              type="textarea"
              v-model="ModifyForm.h5Url"
              maxlength="200"
              placeholder="请输入h5跳转链接"
            ></el-input>
          </el-form-item>

          <div style="text-align: center;margin-top: 50px">
            <el-button
              type="primary"
              @click="modifySubmit"
              :loading="submitLoading"
            >确认修改</el-button>
          </div>
        </el-form>
      </div>
      <!-- 产品列表 -->
      <div
        v-if="NewProduct"
        class="list"
      >
        <div class="release">
          <el-button @click="newProduct">发布新产品</el-button>
        </div>
        <!-- =================================================================== -->
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane
            label="待审批"
            name="first"
          >
            <div>
              <el-table
                :data="tableData"
                stripe
                style="width: 100%"
              >
                <el-table-column
                  prop="name"
                  label="产品名称"
                >
                </el-table-column>
                <el-table-column
                  prop="checkTime"
                  label="审核时间"
                >
                </el-table-column>
                <!-- <el-table-column
                  prop="address"
                  label="关注户数"
                >
                </el-table-column>
                <el-table-column
                  prop="sq"
                  label="申请户数"
                >
                </el-table-column>
                <el-table-column
                  prop="sx"
                  label="授信户数"
                >
                </el-table-column> -->
                <!-- <el-table-column
                  prop="je"
                  label="授信金额(万元)"
                  width="150px"
                >
                </el-table-column> -->
                <el-table-column
                  prop="parentName"
                  label="审核状态"
                >
                  <!-- <template slot-scope="scope">
                    <div v-if="scope.row.status==1">运行中</div>
                    <div v-if="scope.row.status==2"> 待审批</div>
                    <div v-if="scope.row.status==0">已下架</div>
                  </template> -->
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="200"
                >
                  <template slot-scope="scope">
                    <!-- <div style="display:flex;justify-content: space-between;">
                      <span
                        style=" white-space:nowrap; color:#F85B4B;"
                        @click="disable(scope.row)"
                      >停用</span> -->
                    <!-- <span style=" white-space:nowrap; color:#2981EE;">修改</span> -->
                    <!-- <span
                        style=" white-space:nowrap; color:#B1B1B1;"
                        @click="dialogVisible = true"
                      >上报成效</span>
                    </div> -->
                    <span
                      @click="detiles(scope.row)"
                      style="color:blue"
                    >查看详情</span>
                  </template>

                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="运行中"
            name="second"
          >
            <div>
              <el-table
                :data="runTableData"
                stripe
                style="width: 100%"
              >
                <el-table-column
                  prop="name"
                  label="产品名称"
                >
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="上线日期"
                >
                </el-table-column>
                <el-table-column
                  prop="followCount"
                  label="关注户数"
                >
                </el-table-column>
                <el-table-column
                  prop="appCount"
                  label="申请户数"
                >
                </el-table-column>
                <el-table-column
                  prop="creditCount"
                  label="授信户数"
                >
                </el-table-column>
                <el-table-column
                  prop="creditAmount"
                  label="授信金额(万元)"
                  width="150px"
                >
                </el-table-column>
                <el-table-column
                  prop="parentName"
                  label="产品状态"
                >
                  <!-- <template slot-scope="scope">
                    <div v-if="scope.row.status==1">运行中</div>
                    <div v-if="scope.row.status==2"> 待审批</div>
                    <div v-if="scope.row.status==0">已下架</div>
                  </template> -->
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="200"
                >
                  <template slot-scope="scope">
                    <div style="display:flex;justify-content: space-between;">
                      <span
                        style=" white-space:nowrap; color:#F85B4B;"
                        @click="disable(scope.row)"
                      >停用</span>
                      <span
                        style=" white-space:nowrap; color:#2981EE;"
                        @click="Modify(scope.row)"
                      >修改</span>
                      <span
                        style=" white-space:nowrap; color:#2981EE;"
                        @click="report(scope.row)"
                      >上报成效</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="已下架"
            name="third"
          >
            <div>
              <el-table
                :data="shelvesTableData"
                stripe
                style="width: 100%"
              >
                <el-table-column
                  prop="name"
                  label="产品名称"
                >
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="上线日期"
                >
                </el-table-column>
                <el-table-column
                  prop="followCount"
                  label="关注户数"
                >
                </el-table-column>
                <el-table-column
                  prop="appCount"
                  label="申请户数"
                >
                </el-table-column>
                <el-table-column
                  prop="creditCount"
                  label="授信户数"
                >
                </el-table-column>
                <el-table-column
                  prop="creditAmount"
                  label="授信金额(万元)"
                  width="150px"
                >
                </el-table-column>
                <el-table-column
                  prop="parentName"
                  label="产品状态"
                >
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="200"
                >
                  <template slot-scope="scope">
                    <div style="display:flex;justify-content: space-between;">
                      <span
                        style=" white-space:nowrap; color:green;"
                        @click="enable(scope.row)"
                      >启用</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="审批历史"
            name="four"
          >
            <div>
              <el-table
                :data="HistoryList"
                stripe
                style="width: 100%"
              >
                <el-table-column
                  prop="name"
                  label="产品名称"
                >
                </el-table-column>
                <!-- <el-table-column
                  prop="createTime"
                  label="审核状态"
                >
                </el-table-column> -->
                <el-table-column
                  prop="statusName"
                  label="审核状态"
                >
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="审核时间"
                >
                </el-table-column>
                <!-- <el-table-column
                  prop="sq"
                  label="申请户数"
                >
                </el-table-column>
                <el-table-column
                  prop="sx"
                  label="授信户数"
                >
                </el-table-column>
                <el-table-column
                  prop="je"
                  label="授信金额(万元)"
                  width="150px"
                >
                </el-table-column> -->

                <el-table-column
                  label="操作"
                  width="200"
                >
                  <template slot-scope="scope">
                    <div>
                      <span
                        @click="detiles(scope.row)"
                        style="color:blue"
                      >查看详情</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!-- =================================================================== -->
        <el-dialog
          title="查看详情"
          :visible.sync="Detail"
          width="25%"
          center
          :show-close="false"
          :modal-append-to-body="false"
          :lock-scroll="false"
        >
          <div class="details">
            <div>产品简介：<span>{{DetailList.name}}</span></div>
            <div>
              贷款额度：<span>{{DetailList.loanLimitFloor}}-{{DetailList.loanLimitCap}}
                万元</span>
            </div>
            <div>
              利率范围：<span>{{DetailList.interestRateFloor}}-{{DetailList.interestRateCap}}
                %</span>
            </div>
            <div>
              贷款期限：<span>{{DetailList.minLoanTime}}-{{DetailList.maxLoanTime}}
                月</span>
            </div>
            <div>贷款类型：<span>{{DetailList.typeName}}</span></div>
            <div>
              申请条件：<span>{{DetailList.conditions}}</span>
            </div>
            <div>
              所需材料：<span>{{DetailList.materials}}</span>
            </div>
            <div>
              审批意见：<span>{{DetailList.reson}}</span>
            </div>
          </div>
          <div class="button">
            <el-button @click="Detail = false">确 认</el-button>
          </div>
        </el-dialog>
        <!-- =============================================== -->
        <el-dialog
          title="上报成效"
          :visible.sync="dialogVisible"
          :width="dialogWidth"
          :show-close="false"
          :modal-append-to-body="false"
          :lock-scroll="false"
        >
          <div class="credit">
            <div class="el_input">授信户数 <el-input-number
                :min="0"
                :max="100000"
                :controls="false"
                v-model="sx"
              ></el-input-number><span>户</span>
            </div>
            <div class="el_input">

              授信金额<el-input-number
                :min="0"
                :max="100000000"
                :controls="false"
                v-model="je"
              ></el-input-number><span>万元</span>
            </div>
            <div class="button">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button
                class="el-button1"
                type="primary"
                @click="results"
              >确 定</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductType, addProduct, getDictName, list, detail, reportInformation, selectProType, existExamine, selectHistoryList } from "@/api/production";
import { detailByExamineId } from "@/api/statistics";
import TopMessage from "@/components/TopMessage";
import utils from "@/utils/utils"
export default {
  components: { TopMessage },
  data () {
    return {
      f: false,
      maxNumber: 100000000,
      submitLoading: false,
      submitForm: {
        name: "",
        proIntroduction: "",
        loanLimitFloor: undefined,
        loanLimitCap: undefined,
        interestRateFloor: undefined,
        interestRateCap: undefined,
        minLoanTime: undefined,
        maxLoanTime: undefined,
        conditions: "",
        materials: "",
        webUrl: '',
        h5Url: '',
        typeId: ''
      },
      ModifyForm: {
        typeId: '',
        name: "",
        proIntroduction: "",
        loanLimitFloor: undefined,
        loanLimitCap: undefined,
        interestRateFloor: undefined,
        interestRateCap: undefined,
        minLoanTime: undefined,
        maxLoanTime: undefined,
        conditions: "",
        materials: "",
        webUrl: '',
        h5Url: ''
      },
      showInfo: {
        name: "",
        bankName: "",
        typeName: "",
        loanLimitFloor: "",
        loanLimitCap: "",
        interestRateFloor: "",
        interestRateCap: "",
        minLoanTime: "",
        maxLoanTime: "",

      },
      submitRule: {
        typeId: [
          { required: true, message: "请选择产品类型", trigger: "change" }
        ],
        name: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
        ],
        proIntroduction: [
          { required: true, message: '请输入产品介绍', trigger: 'blur' },
        ],
        loanLimitFloor: [
          { required: true, message: "请输入贷款金额", trigger: "blur" }
        ],
        loanLimitCap: [
          { required: true, message: "请输入贷款金额", trigger: "blur" }
        ],
        interestRateFloor: [
          { required: true, message: "请输入利率范围", trigger: "blur" }
        ],
        interestRateCap: [
          { required: true, message: "请输入利率范围", trigger: "blur" }
        ],
        minLoanTime: [
          { required: true, message: "请输入贷款期限", trigger: "blur" }
        ],
        maxLoanTime: [
          { required: true, message: "请输入贷款期限", trigger: "blur" }
        ],
        type: [
          { required: true, message: "请选择贷款类型", trigger: "change" }
        ],
        conditions: [
          { required: true, message: "请输入贷款条件", trigger: "blur" }
        ],
        materials: [
          { required: true, message: "请输入所需材料", trigger: "blur" }
        ],
        // webUrl: [
        //   { required: true, message: "请输入Web端跳转链接", trigger: "blur" }
        // ],
        // h5Url: [
        //   { required: true, message: "请输入h5跳转链接", trigger: "blur" }
        // ],
      },
      typeOption: [],
      tableData: [],
      runTableData: [],
      shelvesTableData: [],
      dialogVisible: false,
      NewProduct: true,
      success: false,
      activeName: 'first',
      status: 1,
      modifyStatus: false,
      ReportCredit: {},
      sx: undefined,
      je: undefined,
      Url: '',
      dialogWidth: "370px",
      selectProTypeList: [],
      Detail: false,
      DetailList: [],
      HistoryList: [],
    }
  },
  created () {
    getProductType({ code: "00104" }).then(res => {
      // res = this.paramDecrypt(res);
      if (res.data.code === 200) {
        this.typeOption = res.data.data;
      }
    });
    this.getList()
    this.getselectProType()
  },
  mounted () {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  methods: {
    detiles (e) {
      let params = { id: e.id }
      detailByExamineId(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code === 200) {
          this.DetailList = res.data
        }
      })
      this.Detail = true
      this.DetailList = e
    },
    getselectProType () {
      selectProType().then(res => {
        res = this.paramDecrypt(res);
        if (res) {
          this.selectProTypeList = res
        }
      })
    },
    setDialogWidth () {
      var val = document.body.clientWidth
      const def = 370 // 默认宽度
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    },
    //获取产品列表
    getList () {
      let params = { status: this.status }
      list(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          res.data.forEach((item) => {
            item.checkTime = utils.timestampToTimeLong(item.checkTime)
          });
          if (this.status == 1) {
            this.tableData = res.data
          } else if (this.status == 2) {
            res.data.forEach((item) => {
              item.createTime = utils.timestampToTimeLong(item.createTime)
            })
            this.runTableData = res.data
          } else if (this.status == 3) {
            this.shelvesTableData = res.data
          }
        }

      }).catch(err => {

      })
    },
    Return () {
      this.getList()
      this.success = false
      this.NewProduct = true
    },
    report (e) {
      this.dialogVisible = true
      this.ReportCredit = e
      this.je = e.creditAmount
      this.sx = e.creditCount
    },
    results () {
      let params = {
        id: this.ReportCredit.id,
        creditCount: this.sx,
        creditAmount: this.je
      }
      reportInformation(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          this.$message.success('上报成功')
          this.getList()
        }
      }).catch(err => {

      })
      this.dialogVisible = false
    },
    handleSubmit () {
      this.$refs.submitForm.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          let params = {
            productInfo: this.submitForm,
            operateType: "add"
          }
          addProduct(this.sendParam(params)).then(res => {
            res = this.paramDecrypt(res);
            this.submitLoading = false;
            if (res.code === 200) {
              this.$message.success("发布成功");
              this.showInfo = res.data;
              getDictName({ code: res.data.type }).then(res => {
                res = this.paramDecrypt(res);
                if (res.code === 200) {
                  this.showInfo.typeName = res.data.name;
                  this.f = false;
                  this.success = true
                }
              });
              let params = { id: res.data.id }
              detail(this.sendParam(params)).then(res => {
                res = this.paramDecrypt(res);
                if (res.code === 200) {
                  this.Url = res.data.proIcon
                }
              });
            } else {
              this.$message.error(res.msg);
            }
          });
          //
        }
      })
    },
    //修改产品属性
    Modify (e) {
      let data = { id: e.id }
      existExamine(this.sendParam(data)).then(res => {
        if (res.status === 200) {
          res = this.paramDecrypt(res);
          if (res.code === 200) {
            let params = { id: e.id }
            detail(this.sendParam(params)).then(res => {
              res = this.paramDecrypt(res);
              if (res.code === 200) {
                let list = res.data
                list.interestRateCap = parseFloat(list.interestRateCap)
                list.interestRateFloor = parseFloat(list.interestRateFloor)
                list.maxLoanTime = parseInt(list.maxLoanTime)
                list.minLoanTime = parseInt(list.minLoanTime)
                this.ModifyForm = list
                this.modifyStatus = true
                this.NewProduct = false;
              }
            }).catch(err => { })
          } else if (res.code == 202) {
            this.$message.error(res.msg)
          }
        }
      })
    },

    getSelectHistoryList () {
      let parasm = {}
      selectHistoryList(this.sendParam(parasm)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          res.data.forEach((item) => {
            item.createTime = utils.timestampToTimeLong(item.createTime)
          })
          this.HistoryList = res.data;
        }
      }).catch(err => { })
    },
    //修改产品发布
    modifySubmit () {
      this.$refs.submitForm.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          let params = {
            productInfo: this.ModifyForm,
            operateType: "edit"
          }
          addProduct(this.sendParam(params)).then(res => {
            res = this.paramDecrypt(res);
            this.submitLoading = false;
            if (res.code === 200) {
              this.$message.success("修改申请提交成功");
              // this.showInfo = res.data;
              // this.success = true
              // getDictName({ code: res.data.type }).then(response => {
              //   response = this.paramDecrypt(response);
              //   if (response.code === 200) {
              //     this.showInfo.typeName = response.data.name;
              //     this.f = false;
              //   }
              // });
              this.modifyStatus = false
              this.NewProduct = true
              this.getList()
            } else {
              this.$message.error(res.msg);
            }
          });
          //
        }
      })
    },
    //发布新产品
    newProduct () {
      this.NewProduct = false;
      this.f = true;
    },
    handleClick (e) {
      if (e.index == 0) {
        this.status = 1
        this.getList()
      } else if (e.index == 1) {
        this.status = 2
        this.getList()
      } else if (e.index == 2) {
        this.status = 3
        this.getList()
      } else if (e.index == 3) {
        this.getSelectHistoryList()
      }
    },
    // 停用
    disable (e) {
      let params = {
        productInfo: e,
        operateType: "stop"
      }
      addProduct(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code === 200) {
          this.$message.success("停用成功")
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //启用
    enable (e) {
      let params = {
        productInfo: e,
        operateType: "start"
      }
      addProduct(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code === 200) {
          this.$message.success("启用成功,待审核")
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.bottomPart {
  width: 100%;
  min-height: 640px;
  background: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
    margin-bottom: 20px;
  }
}
.form {
  border-top: 1px solid #f3f4f9;
  padding: 60px 250px;
  .el-input-number {
    margin-right: 5px;
  }
}
.show {
  border-top: 1px solid #f3f4f9;
  padding: 30px 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .a1 {
    width: 764px;
    height: 280px;
    background: #f9f9f9;
    border: 1px solid #d5d5d5;
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    padding: 0 100px;
    box-sizing: border-box;
    .b1 {
      width: 138px;
      height: 58px;
      margin-top: 30px;
    }
    .b2 {
      font-size: 22px;
      font-weight: 550;
      margin-top: 10px;
    }
    .b3 {
      border: 1px solid #2981ee;
      color: #2981ee;
      background: white;
      font-size: 16px;
      padding: 5px 20px;
      border-radius: 10px;
      margin-top: 10px;
    }
    .b4 {
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 20px;
      .c {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .d1 {
          font-size: 26px;
          font-weight: bold;
        }
        .d2 {
          color: #b90c1c;
        }
        .d3 {
          font-size: 16px;
          color: #595858;
          margin-top: 5px;
        }
      }
      .el-divider {
        height: 40px;
      }
    }
  }
  .a2 {
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
  }
  .a3 {
    font-size: 22px;
    font-weight: 550;
  }
}
.list {
  width: 100%;
  .release {
    width: 100%;
    height: 66px;
    background: #f6fafe;
    padding-right: 30px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .el-button {
      width: 142px;
      height: 40px;
      background: #2981ee;
      border-radius: 6px;
      font-size: 16px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #ffffff;
    }
  }
  /deep/ .el-table th {
    text-align: center;
    font-size: 16px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #252525;
    background-color: #f5f6fa;
  }
  /deep/ .el-table td {
    text-align: center;
    font-size: 15px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #252525;
  }
}
</style>
<style lang="less">
.el-dialog__body {
  .credit {
    display: flex;
    flex-direction: column !important;
    height: 200px;
    justify-content: space-between !important;
    .button {
      display: flex;
      justify-content: space-between !important;
      .el-button {
        width: 140px;
        height: 44px;
        background: #f3f4f9;
        border: 1px solid #a2a4ac;
        border-radius: 8px;
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #2a2a2a;
      }
      .el-button1 {
        width: 140px;
        height: 44px;
        background: #2981ee;
        border: 1px solid #2981ee;
        border-radius: 8px;
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #ffffff;
      }
    }
    .el_input {
      position: relative;

      .el-input-number {
        margin-left: 15px;
      }
      span {
        position: absolute;
        right: 97px;
        top: 8px;
        font-size: 18px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #a9acb7;
      }
    }
  }
}
</style>
<style lang="less" scoped>
/deep/.el-tabs__header {
  margin: 0;
  .el-tabs__item.is-active {
    font-size: 18px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #2a2a2a;
  }
  .el-tabs__item is-top {
    font-size: 14px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #818181;
  }

  .el-tabs__item {
    color: #818181;
    cursor: pointer;
  }
}
/deep/.el-tabs__nav-wrap::after {
  display: none;
}
/deep/ .el-tabs__header {
  padding-left: 50px;
  height: 40px;
  background-color: #f3f4f9;
}
/deep/ .el-table__header {
  border-top: 1px solid #fff;
}
.details {
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 600;
  color: #000000;
  div {
    margin-top: 15px;
    span {
      font-size: 16px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #2a2a2a;
    }
  }
}
.button {
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
